 var addtocart_selector = '';
 var variant_dropdown_selector = '.ProductForm__Variants';
 var qty_selector ='.ProductForm__QuantitySelector';
 var enable_pvt_app = 'yes';
 var show_floating_cart = 'yes';
 var show_tbl_after_customer_logged_in = 'no';
 var redirect_cart_page = 'no';
 var hide_price = 'no';
 var hide_price_text = 'Call for price';
 var hide_add_to_cart_btn = 'yes';
 var hide_variant_dropdowns = 'yes';
 var hide_qty_box = 'yes';
 var show_out_of_stock = 'yes';
 var currency_code_included = 'yes';
 var default_qty_val = '0';
 var single_atc_status = 'NO';
 var variant_img_size = 'small';
 var enable_filter = 'no';
 var in_stock_txt = 'In Stock';
 var out_of_stock_txt = 'Out Of Stock';
 var price_txt = 'Price';
 var qty_txt = 'Quantity';
 var added_btn_text='Added...';
 var adding_btn_text='Adding...';
 var add_more_btn_text='ADD MORE...';
 var thank_you_btn_text='Thank You...';
 var bulk_add_to_cart_text = 'Add to cart';
 var add_to_cart_text = 'ADD TO CART';
 var stock_alert='We have maximum %s items in stock';
 var modal_header_txt = 'Your cart has %s items';
 var product_name = 'Product Name';
 var modal_subtotal_txt='Subtotal';
 var modal_viewbtn_txt='View Cart';
 var modal_contbtn_txt='Continue Shopping';
 var error1_text1='You can only add';
 var error1_text2='to the cart.';
 var error2_text1='All';
 var error2_text2='are in your cart.';
 var error3_text1='You can\'t add more';
 var show_in_stock_text='yes';